<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingResidenceInformation$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.residence.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'child-onboarding.residence.text' | transloco }}</p>

  <p class="zero-text p-base-reg">
    <span class="zero-text p-base-med">{{ 'child-onboarding.residence.residence-label' | transloco }}:</span>
    {{ 'child-onboarding.residence.residence-germany' | transloco }}
    <web-design-system-icon
      class="cursor-pointer"
      name="info"
      color="dimmed"
      [ngbTooltip]="'child-onboarding.residence.residence-hint' | transloco"
      tooltipClass="zero-tooltip"
      placement="bottom"
      triggers="hover click"
    />
  </p>

  <div ngbDropdown>
    <web-design-system-input
      ngbDropdownToggle
      class="d-block mt-4"
      [icon]="'magnifier'"
      [label]="'child-onboarding.residence.address-label' | transloco"
      [value]="searchTerm$ | async"
      [isValid]="
        (street$ | async | notEmpty) && (streetNumber$ | async | notEmpty) && (zip$ | async | notEmpty) && (city$ | async | notEmpty)
      "
      [autocomplete]="false"
      (valueChange)="handleSearchTermChange($event)"
    />
    <div ngbDropdownMenu>
      <div class="suggestion" ngbDropdownItem (click)="useAdress(null, addressModal)" (keyup.Enter)="useAdress(null, addressModal)">
        <div class="d-flex gap-small">
          <div class="zero-text p-base-reg">{{ 'child-onboarding.residence.no-addresses-found' | transloco }}</div>
          <div class="zero-text p-base-reg link">{{ 'child-onboarding.residence.no-addresses-found-link' | transloco }}</div>
        </div>
      </div>
      @if (addressSuggestions$ | async; as suggestions) {
        @for (suggestion of suggestions; track $index; let isLast = $last) {
          <div
            class="suggestion"
            [class.last]="isLast"
            ngbDropdownItem
            (click)="useAdress(suggestion, addressModal)"
            (keyup.Enter)="useAdress(suggestion, addressModal)"
          >
            @if (suggestion?.street) {
              <div class="zero-text p-base-reg">
                {{ suggestion.street }}{{ suggestion.streetNumber ? ' ' + suggestion.streetNumber : '' }}
              </div>
            }
            @if (suggestion?.city) {
              <div class="zero-text p-base-reg">
                {{ suggestion.street || suggestion.streetNumber ? ', ' : '' }}{{ suggestion.zip
                }}{{ suggestion.zip && suggestion.city ? ' ' : '' }}{{ suggestion.city }}
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
  <a (click)="copy()" class="link-secondary font-default cursor-pointer">{{
    'child-onboarding.residence.copy-addresses-link' | transloco
  }}</a>
</child-onboarding-container>

<ng-template #addressModal let-modal>
  <web-design-system-modal [headline]="'child-onboarding.residence.modal.headline' | transloco" (dismiss)="dismissModal(modal)">
    <div class="row">
      <div class="col-12 col-sm-8">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'child-onboarding.residence.modal.street' | transloco"
          [value]="street$ | async"
          [autocomplete]="false"
          (valueChange)="handleStreetChange($event)"
        />
      </div>
      <div class="col-12 col-sm-4">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'child-onboarding.residence.modal.streetNumber' | transloco"
          [value]="streetNumber$ | async"
          [autocomplete]="false"
          (valueChange)="handleStreetNumberChange($event)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'child-onboarding.residence.modal.addition' | transloco"
          [value]="addition$ | async"
          [autocomplete]="false"
          (valueChange)="handleAdditionChange($event)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'child-onboarding.residence.modal.zip' | transloco"
          [value]="zip$ | async"
          [autocomplete]="false"
          (valueChange)="handleZipChange($event)"
        />
      </div>
      <div class="col-12 col-sm-8">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'child-onboarding.residence.modal.city' | transloco"
          [value]="city$ | async"
          [autocomplete]="false"
          (valueChange)="handleCityChange($event)"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <web-design-system-button class="mt-4" (click)="dismissModal(modal); submit()" [disabled]="(isFormValid$ | async) === false">
        {{ 'child-onboarding.residence.modal.btn' | transloco }}
      </web-design-system-button>
    </div>
  </web-design-system-modal>
</ng-template>
